export default "__VITE_ASSET__3dbb797e__"